<script lang="ts">
  import type { FieldState } from '@shared/types';
  import type { ElementSize } from '@shared/types';
  import { IconButton } from '@shared/ui/buttons/icon-button';
  import { Icon } from '@shared/ui/icon';
  import { Tooltip } from '@shared/ui/tooltip';

  export let state: FieldState = 'default';
  export let label: string | undefined = undefined;
  export let hint: string | undefined = undefined;
  export let hasClear: boolean = false;
  export let onClear: (() => void) | undefined = undefined;
  export let size: ElementSize = 'sm';
  export let description: string | undefined = undefined;
</script>

{#if label || hasClear || onClear}
  <div class="mb-2 flex w-full flex-wrap justify-between">
    <div
      class="{size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-lg' : 'text-base'}
			text-default-900 flex items-center gap-1 font-medium {state === 'disabled' ? 'dark:text-dark-700' : 'dark:text-white'}"
    >
      {#if label}
        {label}
      {/if}

      {#if hint}
        <Tooltip>
          <div class="w-60">
            {hint}
          </div>
        </Tooltip>
      {/if}
    </div>
    {#if hasClear}
      <div>
        <IconButton size="{18}" icon="close" on:click="{onClear}" variant="quaternary" />
      </div>
    {/if}
  </div>
{/if}
{#if description}
  <p class="text-default-800 dark:text-dark-800 mb-4 mt-4 flex items-start gap-2 text-xs">
    <span>
      <Icon name="info" />
    </span>
    <span class="pt-0.5">
      {description}
    </span>
  </p>
{/if}
